import { isWeb } from '../shared/utils/is';

const initBackboneApp = () => {
    /**
     * Our application logic is now setup.  Time to build our Marionette
     * application router and then init the thing
     */
    const application = new Backbone.Marionette.Application();

    application.addRegions({
        content: '#content',
        content_overlay: '#content_overlay', // should be access through $f.mobile.nav.show_modal
        bottom_sheet: '#bottom_sheet'
    });

    /**
     * Our initialization code
     */
    window._open = window.open;
    $(document).ready(function () {
        const onDeviceReady = async function () {
            $f.mobile.load_sentry(); // load sentry first so we catch any init errors
            await $f.mobile.preInit();
            $f.mobile.init(function () {
                $f.mobile.start();
            });
        };

        if (isWeb()) {
            window.addEventListener('blur', function (e) {
                application.vent.trigger('mobile:blur');
            });

            window.addEventListener('focus', function (e) {
                application.vent.trigger('mobile:focus');
            });

            onDeviceReady();
        } else {
            // if event already called, event will fire immediately (http://stackoverflow.com/a/14109006/477632):
            document.addEventListener('deviceready', onDeviceReady, false);
        }
    });

    return application;
};

export default initBackboneApp;
